import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "1",
    title: "Understand",
    subtitle: "Make sense of your journey",
    text: "Explore the changes you may be experiencing during menopause and midlife. Through menopause education, guided reflection and supportive discussions, you can identify the questions that matter to you, build your understanding and consider what information or support may help you move forward.",
  },
  {
    n: "2",
    title: "Reset",
    subtitle: "Give yourself permission to pause",
    text: "Step away from the constant demands of everyday life and create room to focus on yourself. Reflect on your wellbeing, daily routines, boundaries and priorities, and explore practical ways to make more space for your needs.",
  },
  {
    n: "3",
    title: "Reconnect",
    subtitle: "Find space to hear yourself again",
    text: "Reconnect with your identity beyond your job title, business or responsibilities. Take time to consider your confidence, relationships, ambitions and personal values, while connecting with other women navigating similar life transitions.",
  },
  {
    n: "4",
    title: "Reclaim",
    subtitle: "Begin shaping your next chapter",
    text: "Look ahead with fresh perspective. Through guided reflection and personal planning, begin identifying the changes you would like to make, the support you may need and the practical next steps that feel right for you.",
  },
];

export const Framework = () => (
  <section data-testid="framework-section" className="border-t border-[rgba(163,74,107,0.18)] bg-[#F9F3EE]">
    <div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 lg:py-32">
      <Reveal>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#A34A6B]">The Reclaim Framework</p>
        <h2 className="max-w-2xl font-serif text-2xl leading-snug text-cream sm:text-3xl lg:text-4xl">
          What you can expect from your <span className="italic text-[#A34A6B]">retreat experience.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-2 lg:gap-8">
        {STEPS.map((step, i) => (
          <Reveal key={step.n} delay={i * 0.1}>
            <div
              data-testid={`framework-step-${step.n}`}
              className="h-full rounded-3xl border border-[rgba(163,74,107,0.15)] bg-white/70 p-8 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-[#A34A6B]/40 hover:shadow-[0_20px_60px_rgba(163,74,107,0.12)] sm:p-10"
            >
              <div className="flex items-baseline gap-4">
                <span className="font-serif text-4xl italic text-[#A34A6B]/35">{step.n}</span>
                <div>
                  <h3 className="font-serif text-xl text-[#A34A6B] sm:text-2xl">{step.title}</h3>
                  <p className="mt-1 font-serif text-base italic text-cream/80">{step.subtitle}</p>
                </div>
              </div>
              <p className="mt-5 text-sm leading-relaxed text-lilac">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
